<div class="h-100 overflow-auto crm-scroll">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white position-sticky top-0 z-5">
    <h4 class="m-0 text-crm">Замовити сайт</h4>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onNoClick()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  @if (siteForm) {
    <div class="d-flex flex-column gap-3 px-4 py-2" [formGroup]="siteForm">
      <app-text-field
        label="{{ 'name' | translate }}"
        [required]="true"
        [formControl]="siteForm.controls.name"
        (focusout)="siteForm.controls.name.markAsTouched()"
      ></app-text-field>
      @if (siteForm.controls.name.touched && siteForm.controls.name.invalid) {
        <mat-hint class="text-danger">
          {{ 'field_cannot_be_empty' | translate }}
        </mat-hint>
      }
      <app-phone-field
        label="{{ 'phone' | translate }}"
        [required]="true"
        [formControl]="siteForm.controls.phone"
        (focusout)="siteForm.controls.phone.markAsTouched()"
      ></app-phone-field>
      @if (siteForm.controls.phone.touched && siteForm.controls.phone.invalid) {
        <mat-hint class="text-danger">
          @if (siteForm.controls.phone.errors?.['required']) {
            {{ 'field_cannot_be_empty' | translate }}
          }
        </mat-hint>
      }
      <div class="form-group">
        <p class="text">{{ 'description' | translate }}<span class="required-star">*</span></p>
        <textarea
          cdkTextareaAutosize
          class="w-100 description-area crm-scroll"
          maxlength="9000"
          [formControl]="siteForm.controls.description"
          (focusout)="siteForm.controls.description.markAsTouched()"
        ></textarea>
        <div class="d-flex justify-content-between">
          @if (siteForm.controls.description.touched && siteForm.controls.description.invalid) {
            <mat-hint class="text-danger">
              @if (siteForm.controls.description.errors?.['required']) {
                {{ 'field_cannot_be_empty' | translate }}
              }
            </mat-hint>
          }
          <div class="flex-fill"></div>
          <mat-hint>{{ siteForm.controls.description.value?.length || 0 }}/9000</mat-hint>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="bg-white d-flex position-sticky bottom-0 gap-2 p-4">
        <app-button [customClass]="'bg-danger'" class="mt-2" (onChangeClick)="onNoClick()"
          >{{ 'cancel' | translate }}
        </app-button>
        <div class="flex-fill"></div>
        <app-button class="mt-2" (onChangeClick)="onSubmit()">{{ 'order' | translate }}</app-button>
      </div>
    </div>
  }
</div>
